import React from 'react';
import './PlanSwapTodayModal.css';

const PlanSwapTodayModal = ({ close, onSelect }) => {
  const handlePick = (strategy) => {
    onSelect(strategy);
    close();
  };

  return (
    <div className="plan-swap-today-modal">
      <h2 className="plan-swap-today-header">Switch plan — today's activities?</h2>
      <p className="plan-swap-today-subhead">
        You already have activities for today. What should happen with them?
      </p>

      <div className="plan-swap-today-options">
        <button
          type="button"
          className="plan-swap-today-option plan-swap-today-option-skip"
          onClick={() => handlePick('skip')}
        >
          <span className="plan-swap-today-option-title">Keep today as is</span>
          <span className="plan-swap-today-option-desc">
            Leave today's existing activities. The new plan starts tomorrow.
          </span>
        </button>

        <button
          type="button"
          className="plan-swap-today-option plan-swap-today-option-replace"
          onClick={() => handlePick('replace')}
        >
          <span className="plan-swap-today-option-title">Replace today</span>
          <span className="plan-swap-today-option-desc">
            Remove today's pending plan activities, then add the new plan's activities for today.
          </span>
        </button>

        <button
          type="button"
          className="plan-swap-today-option plan-swap-today-option-add"
          onClick={() => handlePick('add')}
        >
          <span className="plan-swap-today-option-title">Add to today</span>
          <span className="plan-swap-today-option-desc">
            Keep today's existing activities AND add the new plan's activities for today.
          </span>
        </button>
      </div>

      <button type="button" className="plan-swap-today-cancel" onClick={close}>
        Cancel
      </button>
    </div>
  );
};

export default PlanSwapTodayModal;
